function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-16.000000, -3.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M16,13.4166667 L24.3333333,13.4166667 L24.3333333,3 L16,3 L16,13.4166667 Z M16,21.75 L24.3333333,21.75 L24.3333333,15.5 L16,15.5 L16,21.75 Z M26.4166667,21.75 L34.75,21.75 L34.75,11.3333333 L26.4166667,11.3333333 L26.4166667,21.75 Z M26.4166667,3 L26.4166667,9.25 L34.75,9.25 L34.75,3 L26.4166667,3 Z"
})));

const SvgDashboardIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "19px",
  height: "19px",
  viewBox: "0 0 19 19",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgDashboardIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboard-icon.74237976.svg";
export { ForwardRef as ReactComponent };